/* derw-quick-order.js | wholesale.dryeyerescue.com, 2 Oct 2026
   The quick order page, templates/collection.quick-order.liquid.
   Catalogue from templates/collection.quick-order-data.liquid; tiers and the
   discount-code state from window.DERWVolumeDiscount (assets/derw-vcd.js);
   order history from the template's #derw-qo-orders JSON.

   SHOPPING INSIDE THE CART, Aaron 2 Oct: "each line has a add to cart, that
   build the cart on the page and the real cart to check out, they are synced,
   its like shopping while in the cart already".
   - A row not in the cart has a quantity box and its own Add to cart button
     (Enter in the box does the same). It goes straight into the real cart.
   - A row in the cart shows the cart's quantity. Changing it updates the cart
     after a short pause, or at once on leaving the box; Remove takes it out.
   - "Your cart" at the top lists the real cart with its own totals and a
     Checkout button. Changes made elsewhere (cart drawer, another tab) are
     read back in, so the page and the cart never disagree.
   While a change is saving, totals are projected at the tier it reaches;
   once saved they are the cart's own numbers. */
(function () {
  var root = document.getElementById('derw-qo');
  var rowsEl = document.getElementById('derw-qo-rows');
  if (!root || !rowsEl) return;

  var CFG = {};
  try { CFG = JSON.parse(document.getElementById('derw-qo-cfg').textContent || '{}'); } catch (e) { CFG = {}; }
  CFG.status = CFG.status || {};

  var fmt = new Intl.NumberFormat('en-US', { style: 'currency', currency: CFG.currency || 'USD' });
  var money = function (cents) { return fmt.format((cents || 0) / 100); };
  var CHECKOUT = '/checkout';

  /* Units of each variant this practice has ordered before, from customer.orders. */
  var before = {};
  (CFG.counts || '').split(',').forEach(function (pair) {
    if (!pair) return;
    var p = pair.split(':');
    before[p[0]] = (before[p[0]] || 0) + (parseInt(p[1], 10) || 0);
  });
  var STATUS = { in: CFG.status.in, soon: CFG.status.soon, out: CFG.status.out };

  var lines = [];            /* one per catalogue variant */
  var index = {};            /* variant id -> line */
  var qty = {};              /* variant id -> quantity in the cart (plus changes still saving) */
  var draft = {};            /* variant id -> quantity typed on a row not yet in the cart */
  var filter = 'all';
  /* Column sort, Aaron 2 Oct: "need to be able to sort by Your Price even
     after a search term" and "sort column by Product too". Applied after the
     search, brand and filter, so it holds through all of them. */
  var sortKey = '', sortDir = 1;
  var PAGE_ROWS = 150;
  var shown = PAGE_ROWS;

  /* The cart as last read. */
  var cart = null, cartQty = {}, cartLine = {};
  var dirty = {};            /* cart changes waiting to be sent */
  var sending = {};          /* cart changes in the request now in flight */
  var inflight = false, flushTimer = null;

  /* Volume discount state from the shared engine. */
  var cartKnown = false, cartUnits = 0, cartCode = false, curPct = 0;

  var $ = function (id) { return document.getElementById(id); };
  var $q = $('derw-qo-q'), $brand = $('derw-qo-brand');
  var $count = $('derw-qo-count'), $total = $('derw-qo-total'), $note = $('derw-qo-note');
  var $add = $('derw-qo-add'), $clear = $('derw-qo-clear'), $msg = $('derw-qo-msg');
  var $addTop = $('derw-qo-add-top'), $clearTop = $('derw-qo-clear-top'), $msgTop = $('derw-qo-msg-top');
  var $state = $('derw-qo-state'), $beforeN = $('derw-qo-before-n'), $pickedN = $('derw-qo-picked-n');
  var $picked = root.querySelector('[data-filter="picked"]');
  var $sumItems = $('derw-qo-sum-items'), $sumStd = $('derw-qo-sum-std'), $sumDisc = $('derw-qo-sum-disc');
  var $sumDiscK = $('derw-qo-sum-disc-k'), $sumTotal = $('derw-qo-sum-total'), $sync = $('derw-qo-sync');
  var $sumLines = $('derw-qo-sum-lines'), $foot = $('derw-qo-foot');

  document.title = 'Quick order | ' + CFG.shop;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function say(kind, html) {
    [$msg, $msgTop].forEach(function (el) {
      if (!el) return;
      el.className = 'derw-qo__msg' + (kind ? ' is-' + kind : '');
      el.innerHTML = html || '';
    });
    syncFoot();
  }
  function keys(o) { return Object.keys(o); }
  function isPending(id) { return dirty.hasOwnProperty(id) || sending.hasOwnProperty(id); }
  function anyPending() { return keys(dirty).length > 0 || keys(sending).length > 0; }
  function byId(id) { return index[id] || null; }
  var unitWord = function (n) { return n === 1 ? 'unit' : 'units'; };

  function statusOf(v) {
    if (!v.a) return 'out';
    if (v.c && v.q !== null && v.q <= 0) return 'soon';
    return 'in';
  }

  /* ---- tiers and exclusions, read as assets/derw-vcd.js reads them ---- */
  function cfgEl() { return document.querySelector('[data-derw-vol], [data-derw-excluded-tags]'); }
  function activeExcluded() {
    var el = cfgEl();
    return ((el && el.getAttribute('data-derw-excluded-tags')) || '').split(',')
      .map(function (x) { return x.trim().toLowerCase(); }).filter(Boolean);
  }
  function tierLists() {
    var el = cfgEl();
    var nums = function (attr, fb) {
      var out = ((el && el.getAttribute(attr)) || '').split(',').map(function (x) { return parseInt(x, 10); }).filter(function (x) { return !isNaN(x); });
      return out.length ? out : fb;
    };
    return { M: nums('data-derw-mins', [1, 10, 20, 100, 200]), P: nums('data-derw-pcts', [0, 5, 10, 15, 20]) };
  }
  function stateFor(q) {
    var api = window.DERWVolumeDiscount;
    if (api && typeof api.stateFor === 'function') return api.stateFor(q);
    var T = tierLists(), i = 0;
    for (var k = 0; k < T.M.length; k++) if (q >= T.M[k]) i = k;
    var next = i < T.M.length - 1;
    return { tierIndex: i, currentDiscountPercent: T.P[i] || 0,
             nextDiscountPercent: next ? T.P[i + 1] : null,
             unitsToNextTier: next ? Math.max(0, T.M[i + 1] - q) : 0, maximumTierReached: !next };
  }

  /* ---- what each practice buys, from its own order history ----
     Aaron 2 Oct: "Last order on each row", a "Due to reorder" list. For each
     variant: the last quantity and date ordered (cancelled orders skipped),
     and, when it was bought on 2 or more dates, the usual gap between orders.
     An item is due once that gap has nearly passed since the last order, and
     stops being flagged after three gaps (or a year), when it has probably
     been dropped rather than forgotten. */
  var MONTHS = { jan: 0, feb: 1, mar: 2, apr: 3, may: 4, jun: 5, jul: 6, aug: 7, sep: 8, oct: 9, nov: 10, dec: 11 };
  function parseD(s) {
    var m = /^([A-Za-z]{3})[a-z]* (\d{1,2}), (\d{4})$/.exec(String(s || '').trim());
    return m ? new Date(+m[3], MONTHS[m[1].toLowerCase()], +m[2]) : null;
  }
  var DAY = 864e5;
  function buyHistory(list, today) {
    var h = {};
    (list || []).forEach(function (o) {
      if (o.x) return;
      var dt = parseD(o.d); if (!dt) return;
      o.li.forEach(function (li) {
        var id = String(li.v); if (!li.v) return;
        var r = h[id] || (h[id] = { last: null, days: {} });
        if (!r.last) r.last = { q: 0, d: dt, label: o.d, n: o.n };
        if (r.last.n === o.n) r.last.q += li.q;
        r.days[dt.getTime()] = 1;
      });
    });
    Object.keys(h).forEach(function (id) {
      var r = h[id];
      var ds = Object.keys(r.days).map(Number).sort(function (a, b) { return b - a; });
      var since = Math.floor((today - r.last.d) / DAY);
      r.since = since;
      if (ds.length < 2) return;
      var gaps = [];
      for (var i = 0; i < ds.length - 1; i++) gaps.push((ds[i] - ds[i + 1]) / DAY);
      gaps.sort(function (a, b) { return a - b; });
      var cad = Math.max(7, Math.round(gaps[Math.floor(gaps.length / 2)]));
      r.cad = cad;
      if (since >= cad - 7 && since <= Math.min(cad * 3, 365)) r.due = { cad: cad, since: since, overdue: since > cad + 14 };
    });
    return h;
  }
  function weeksText(days) {
    if (days < 14) return days + ' days';
    var w = Math.round(days / 7);
    return w < 9 ? w + ' weeks' : Math.round(days / 30) + ' months';
  }

  /* ---- catalogue ---- */
  var OWN_BRAND = /^dry\s*eye\s*rescue/i;
  function build(products) {
    var bought = buyHistory(orders, new Date());
    var rank = 0, blocked = activeExcluded();
    products.forEach(function (p) {
      /* Aaron 2 Oct: DryEye Rescue's own items (displays, kiosks, kits, pads,
         framed canvases, RescueLink) are not ordered here, so they are left
         out. Brand spellings in the store: "DryEye Rescue", "Dryeye Rescue
         Pro", "DryEyeRescueWholesale.com". */
      if (OWN_BRAND.test(p.b || '')) return;
      p.v.forEach(function (v) {
        var ptags = (p.x || '').split('|').filter(Boolean);
        var l = {
          id: String(v.i), p: p, v: v, st: statusOf(v), rank: rank++,
          elig: !ptags.some(function (t) { return blocked.indexOf(t) !== -1; }),
          before: before[String(v.i)] || 0,
          hay: [p.t, p.b, v.t, v.k, p.s, p.l].join(' ').toLowerCase()
        };
        var bh = bought[l.id];
        if (bh) { l.last = bh.last; l.cad = bh.cad; l.due = bh.due || null; }
        lines.push(l); index[l.id] = l;
      });
    });
    /* Aaron 2 Oct: default order is ordered before first (due items at the
       top, then most units), then the best sellers that are in stock, then
       coming soon, then out of stock last. */
    var dueRank = function (l) { return l.due && l.st !== 'out' ? 1 + Math.min(l.due.since / l.due.cad, 3) : 0; };
    var group = function (l) { return l.before ? 0 : l.st === 'in' ? 1 : l.st === 'soon' ? 2 : 3; };
    lines.sort(function (a, b) { return (group(a) - group(b)) || (dueRank(b) - dueRank(a)) || (b.before - a.before) || (a.rank - b.rank); });

    var brands = {};
    lines.forEach(function (l) { if (l.p.b) brands[l.p.b] = 1; });
    keys(brands).sort(function (a, b) { return a.localeCompare(b); }).forEach(function (b) {
      var o = document.createElement('option'); o.value = b; o.textContent = b; $brand.appendChild(o);
    });

    var nBefore = lines.filter(function (l) { return l.before > 0; }).length;
    /* Aaron 2 Oct: open on All products, with the lines ordered before sorted
       first (most units first, see the sort above), not filtered to them. */
    if (nBefore) $beforeN.textContent = '(' + nBefore + ')';
    else root.querySelector('[data-filter="before"]').hidden = true;

    /* "Due to reorder" filter chip and the count in the top band. */
    var nDue = lines.filter(function (l) { return l.due && l.st !== 'out'; }).length;
    if (nDue) {
      var chip = document.createElement('button');
      chip.type = 'button'; chip.className = 'derw-qo__chip derw-qo__chip--due'; chip.setAttribute('data-filter', 'due');
      chip.innerHTML = 'Due to reorder <span>(' + nDue + ')</span>';
      chip.addEventListener('click', function () { setFilter('due'); });
      var bchip = root.querySelector('[data-filter="before"]');
      bchip.parentNode.insertBefore(chip, bchip);
      var read = root.querySelector('.derw-qo-vcd__read');
      if (read) {
        var link = document.createElement('button');
        link.type = 'button'; link.className = 'derw-qo-vcd__due';
        link.textContent = nDue + (nDue === 1 ? ' item is' : ' items are') + ' due to reorder';
        link.addEventListener('click', function () { showTab('order'); $q.value = ''; $brand.value = ''; setFilter('due'); });
        read.appendChild(link);
      }
    }
  }

  function matches(l, terms, brand) {
    if (filter === 'before' && !l.before) return false;
    if (filter === 'due' && !(l.due && l.st !== 'out')) return false;
    if (filter === 'stock' && l.st === 'out') return false;
    if (filter === 'picked' && !qty[l.id]) return false;
    if (brand && l.p.b !== brand) return false;
    for (var i = 0; i < terms.length; i++) if (l.hay.indexOf(terms[i]) === -1) return false;
    return true;
  }
  function ruleText(v) {
    var bits = [];
    if (v.mn > 1) bits.push('Min ' + v.mn);
    if (v.in > 1) bits.push('in steps of ' + v.in);
    if (v.mx) bits.push('max ' + v.mx);
    return bits.join(', ');
  }

  /* The tier a row's price is shown at. Aaron 2 Oct: "when you hit the add
     +10, it should automatically reduce the price shown on that line, even
     before adding to cart to motivate them". A row not yet in the cart with a
     quantity typed (or set by +5/+10) shows the tier the cart would reach
     with it added; every other row shows the cart's own tier. */
  function rowPct(l) {
    if (!l.elig || !cartKnown || cartCode) return 0;
    var d = !qty[l.id] && draft[l.id];
    return d ? stateFor(cartUnits + d).currentDiscountPercent : curPct;
  }
  /* Unit price at that tier, floored like the product page table. */
  function unitPrice(l) { var pc = rowPct(l); return pc > 0 ? Math.floor(l.v.p * (100 - pc) / 100) : l.v.p; }
  /* Projected line total: the percentage off the whole line, as the cart does. */
  function lineCents(l, n) {
    var full = n * l.v.p;
    return (l.elig && curPct > 0) ? Math.round(full * (100 - curPct) / 100) : full;
  }
  /* The cart's own line total once saved; the projection while saving. */
  function lineValue(id, n) {
    var l = byId(id);
    if (!isPending(id) && cartLine[id] && cartQty[id] === n) return cartLine[id].fl;
    return l ? lineCents(l, n) : (cartLine[id] ? cartLine[id].fl : 0);
  }
  function priceHtml(l) {
    var u = unitPrice(l), pc = rowPct(l);
    return (u !== l.v.p ? '<span class="derw-qo__was">' + money(l.v.p) + '</span>' : '') + money(u) +
      (pc > 0 ? '<span class="derw-qo__pct">' + pc + '% off</span>' : '');
  }
  function lineCellHtml(l) {
    var n = qty[l.id] || 0;
    if (n) {
      return '<span class="derw-qo__lt">' + money(lineValue(l.id, n)) + '</span>' +
        '<span class="derw-qo__incart">In cart</span>' +
        '<button type="button" class="derw-qo__rm" data-rm aria-label="Remove ' + esc(l.p.t) + ' from your cart">Remove</button>';
    }
    if (l.st === 'out') return '';
    var lq = l.last ? legal(l.v, l.last.q) : 0;
    return '<button type="button" class="derw-qo__addl" data-addl aria-label="Add ' + esc(l.p.t) + ' to cart">Add to cart</button>' +
      (lq ? '<button type="button" class="derw-qo__addlast" data-addlast aria-label="Add ' + lq + ', the quantity you ordered last time">Add ' + lq + ' like last time</button>' : '');
  }

  function rowHtml(l) {
    var p = l.p, v = l.v, off = l.st === 'out', n = qty[l.id] || 0;
    var box = n || draft[l.id] || '';
    var meta = [v.t, p.s, p.l].filter(Boolean);
    var uniq = meta.filter(function (m, i) { return meta.indexOf(m) === i; });
    if (v.k) uniq.push('SKU ' + v.k);
    if (l.last) uniq.push('Last ordered ' + l.last.q + ' on ' + l.last.label);
    else if (l.before) uniq.push('Ordered before');
    var noDisc = l.elig ? '' : ' · <span class="derw-qo__nodisc">No volume discount</span>';
    var img = p.m ? ' style="background-image:url(&quot;' + esc(p.m) + '&quot;)"' : '';
    var rule = ruleText(v);
    /* Aaron 2 Oct: availability is a dot at the far left of the row, green,
       yellow or red; 97% of lines are in stock, so only the others say why. */
    var stx = l.st !== 'in' ? ' · <span class="derw-qo__stx derw-qo__stx--' + l.st + '">' + esc(STATUS[l.st]) + '</span>' : '';
    var due = l.due && !off ? '<span class="derw-qo__due' + (l.due.overdue ? ' is-over' : '') + '" title="' +
      esc('Usually ordered every ' + weeksText(l.due.cad) + '. Last ordered ' + weeksText(l.due.since) + ' ago.') + '">' +
      (l.due.overdue ? 'Overdue' : 'Due to reorder') + '</span>' : '';
    return '<div class="derw-qo__row' + (off ? ' is-off' : '') + (n ? ' has-qty' : '') + '" role="row" data-id="' + l.id + '">' +
      '<div class="derw-qo__cell--status" role="cell"><span class="derw-qo__dot derw-qo__dot--' + l.st + '" role="img" aria-label="' + esc(STATUS[l.st]) + '" title="' + esc(STATUS[l.st]) + '"></span></div>' +
      '<div class="derw-qo__cell--prod derw-qo__prod" role="cell"><span class="derw-qo__img"' + img + '></span><span class="derw-qo__txt">' +
        '<span class="derw-qo__brand">' + esc(p.b) + due + '</span>' +
        '<a class="derw-qo__name" href="' + esc(p.u) + '" target="_blank" rel="noopener">' + esc(p.t) + '</a>' +
        '<span class="derw-qo__meta">' + esc(uniq.join(' · ')) + noDisc + stx + '</span></span></div>' +
      '<div class="derw-qo__cell--price derw-qo__price is-num" role="cell">' + priceHtml(l) + '</div>' +
      '<div class="derw-qo__cell--qty is-qty" role="cell"><span class="derw-qo__step' + (off ? ' is-off' : '') + '">' +
        '<button type="button" data-step="-1" tabindex="-1" aria-label="Decrease">&minus;</button>' +
        '<input type="number" inputmode="numeric" min="0" step="' + (v.in || 1) + '" value="' + box + '" placeholder="' + (v.mn || 1) + '"' +
          (off ? ' disabled' : '') + ' aria-label="Quantity for ' + esc(p.t + (v.t ? ' ' + v.t : '')) + '">' +
        '<button type="button" data-step="1" tabindex="-1" aria-label="Increase">+</button></span>' +
        /* Aaron 2 Oct: practices buy 20 to 100 of an item, so +5 and +10 save typing or clicking. */
        (off ? '' : '<span class="derw-qo__quick"><button type="button" data-plus="5" tabindex="-1" aria-label="Add 5">+5</button>' +
          '<button type="button" data-plus="10" tabindex="-1" aria-label="Add 10">+10</button></span>') +
        (rule ? '<span class="derw-qo__rule">' + esc(rule) + '</span>' : '') + '</div>' +
      '<div class="derw-qo__cell--line derw-qo__line is-num" role="cell">' + lineCellHtml(l) + '</div>' +
    '</div>';
  }

  function render() {
    if ($reset) syncReset();
    var terms = $q.value.toLowerCase().split(/\s+/).filter(Boolean);
    var brand = $brand.value;
    var hits = sortHits(lines.filter(function (l) { return matches(l, terms, brand); }));
    if (!hits.length) {
      rowsEl.innerHTML = '<p class="derw-qo__state">' +
        (lines.length ? (filter === 'picked' ? 'Your cart is empty.' : 'Nothing matches that search. Try a brand or part of the SKU.') : 'No products are available to order right now.') + '</p>';
      return;
    }
    var html = hits.slice(0, shown).map(rowHtml).join('');
    if (hits.length > shown) {
      html += '<button type="button" class="derw-qo__more" data-more>Show ' + Math.min(PAGE_ROWS, hits.length - shown) +
        ' more of ' + (hits.length - shown) + '</button>';
    }
    rowsEl.innerHTML = html;
  }

  function nameOf(l) { return l.p.t + (l.v.t ? ' ' + l.v.t : ''); }
  function sortHits(h) {
    if (!sortKey) return h;
    return h.slice().sort(function (a, b) {
      var d = sortKey === 'price' ? unitPrice(a) - unitPrice(b)
        : nameOf(a).localeCompare(nameOf(b), undefined, { numeric: true, sensitivity: 'base' });
      return (d * sortDir) || (a.rank - b.rank);
    });
  }
  /* The Product and Your price headers become sort buttons. */
  var heads = root.querySelectorAll('.derw-qo__row--head [role="columnheader"]');
  [[0, 'name', 'Product'], [2, 'price', 'Your price']].forEach(function (x) {
    var h = heads[x[0]]; if (!h) return;
    h.setAttribute('aria-sort', 'none');
    h.innerHTML = '<button type="button" class="derw-qo__sort" data-sort="' + x[1] + '">' + x[2] +
      '<span class="derw-qo__sort-ico" aria-hidden="true"></span></button>';
  });
  /* The availability header moves to the dot column at the far left, as
     "Avail" (Aaron 2 Oct). */
  if (heads[1]) {
    heads[1].textContent = 'Avail';
    heads[1].setAttribute('title', 'Availability');
    heads[1].parentNode.insertBefore(heads[1], heads[0]);
  }
  function markSort() {
    root.querySelectorAll('[data-sort]').forEach(function (b) {
      var on = b.getAttribute('data-sort') === sortKey;
      b.classList.toggle('is-asc', on && sortDir === 1);
      b.classList.toggle('is-desc', on && sortDir === -1);
      b.parentNode.setAttribute('aria-sort', on ? (sortDir === 1 ? 'ascending' : 'descending') : 'none');
      var isName = b.getAttribute('data-sort') === 'name';
      var dir = sortDir === 1 ? (isName ? 'A to Z' : 'low to high') : (isName ? 'Z to A' : 'high to low');
      b.setAttribute('aria-label', 'Sort by ' + (isName ? 'product name' : 'price') + (on ? ', sorted ' + dir : ''));
    });
    if ($sortSel) $sortSel.value = sortKey ? sortKey + ':' + sortDir : '';
  }
  root.addEventListener('click', function (e) {
    var b = e.target.closest('[data-sort]'); if (!b) return;
    var k = b.getAttribute('data-sort');
    /* First click ascending, second descending, third back to the default order. */
    if (sortKey !== k) { sortKey = k; sortDir = 1; }
    else if (sortDir === 1) sortDir = -1;
    else sortKey = '';
    markSort(); shown = PAGE_ROWS; render();
  });
  /* Phones have no column headers, so sorting is a select beside Brand
     (shown below 820px only, Aaron 2 Oct: "this page might be mobile ordering"). */
  var $msort = document.createElement('label');
  $msort.className = 'derw-qo__select derw-qo__msort';
  $msort.innerHTML = '<span class="visually-hidden">Sort</span><select id="derw-qo-sort">' +
    '<option value="">Sort by</option><option value="name:1">Product A to Z</option><option value="name:-1">Product Z to A</option>' +
    '<option value="price:1">Price: low to high</option><option value="price:-1">Price: high to low</option></select>';
  $brand.parentNode.parentNode.insertBefore($msort, $brand.parentNode.nextSibling);
  var $sortSel = $msort.querySelector('select');
  $sortSel.addEventListener('change', function () {
    var v = $sortSel.value.split(':');
    sortKey = v[0] || ''; sortDir = parseInt(v[1], 10) || 1;
    markSort(); shown = PAGE_ROWS; render();
  });
  markSort();

  function rowOf(id) { return rowsEl.querySelector('.derw-qo__row[data-id="' + id + '"]'); }
  function paintRow(row, l) {
    var n = qty[l.id] || 0;
    row.classList.toggle('has-qty', !!n);
    var inp = row.querySelector('input');
    var want = n || draft[l.id] || '';
    if (inp && document.activeElement !== inp && String(inp.value) !== String(want)) inp.value = want;
    var cell = row.querySelector('.derw-qo__line');
    var html = lineCellHtml(l);
    if (cell.getAttribute('data-h') !== html) {
      /* Keep keyboard focus on the row's button when it swaps Add for Remove. */
      var hadFocus = cell.contains(document.activeElement);
      cell.innerHTML = html; cell.setAttribute('data-h', html);
      if (hadFocus) { var f = cell.querySelector('button'); if (f) f.focus(); }
    }
    row.querySelector('.derw-qo__price').innerHTML = priceHtml(l);
  }
  function repaintRows() {
    rowsEl.querySelectorAll('.derw-qo__row[data-id]').forEach(function (row) {
      var l = byId(row.getAttribute('data-id')); if (l) paintRow(row, l);
    });
  }

  /* Round a quantity onto the variant's B2B quantity rule. */
  function legal(v, n) {
    n = Math.max(0, Math.floor(n) || 0);
    if (!n) return 0;
    var inc = v.in || 1, mn = v.mn || 1;
    if (n < mn) n = mn;
    var extra = (n - mn) % inc;
    if (extra) n += inc - extra;
    if (v.mx && n > v.mx) n = v.mx;
    return n;
  }

  /* ---- the cart ---- */
  function applyCart(c) {
    cart = c; cartQty = {}; cartLine = {};
    (c.items || []).forEach(function (it) {
      var id = String(it.variant_id);
      cartQty[id] = (cartQty[id] || 0) + it.quantity;
      var cl = cartLine[id] || (cartLine[id] = { fl: 0, ol: 0, t: it.product_title, vt: it.variant_title || '' });
      /* line_price is the line after the volume discount is spread across it.
         The cart's own total_price is not used: the /cart/update.js response
         returns a stale one (2 Oct: $243.12 there, $235.13 in /cart.js), while
         every line_price is right in both. */
      cl.fl += it.line_price; cl.ol += it.original_line_price;
    });
    /* Everything not mid-save shows exactly what the cart holds. */
    keys(qty).forEach(function (id) { if (!isPending(id) && !cartQty[id]) delete qty[id]; });
    keys(cartQty).forEach(function (id) { if (!isPending(id)) { qty[id] = cartQty[id]; delete draft[id]; } });
    /* Eligible units straight from the cart, so the tier is right before the
       shared engine re-reads it; the engine's answer replaces this when it lands. */
    var u = 0;
    keys(cartQty).forEach(function (id) { var l = byId(id); if (!l || l.elig) u += cartQty[id]; });
    cartUnits = u; cartKnown = true;
    totals(); repaintRows();
  }
  function loadCart() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); }).then(applyCart).catch(function () {});
  }
  /* Tell the theme (header count, drawer) and the discount engine. */
  var selfEvent = false;
  function announceCart() {
    selfEvent = true;
    try { document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { scrollToTop: false } })); } catch (e) {}
    selfEvent = false;
  }

  /* Set a cart quantity and save it shortly. now = save at once. */
  function queue(id, n, now) {
    if (n) qty[id] = n; else delete qty[id];
    dirty[id] = n;
    totals();
    clearTimeout(flushTimer);
    flushTimer = setTimeout(flush, now ? 0 : 700);
  }
  function flush(keepalive) {
    clearTimeout(flushTimer);
    if (inflight || !keys(dirty).length) return;
    var updates = {};
    keys(dirty).forEach(function (id) {
      var l = byId(id);
      updates[id] = l ? legal(l.v, dirty[id]) : dirty[id];
    });
    sending = updates; dirty = {}; inflight = true;
    totals();
    fetch('/cart/update.js', {
      method: 'POST', credentials: 'same-origin', keepalive: !!keepalive,
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ updates: updates })
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error((res.j && (res.j.description || res.j.message)) || 'Your cart could not be updated.');
        sending = {}; inflight = false;
        applyCart(res.j);
        /* Anything the cart would not take in full (stock, quantity rules). */
        var short = keys(updates).filter(function (id) { return !isPending(id) && (cartQty[id] || 0) !== updates[id]; });
        if (short.length) {
          say('err', short.map(function (id) {
            var l = byId(id);
            return esc(l ? l.p.t : 'An item') + ': only ' + (cartQty[id] || 0) + ' could go in your cart.';
          }).join(' '));
        }
      })
      .catch(function (err) {
        sending = {}; inflight = false;
        say('err', esc(err.message) + ' Your cart shows what was saved.');
        return loadCart();
      })
      .then(function () {
        announceCart();
        if (keys(dirty).length) flush(); else totals();
      });
  }
  /* Leaving the page with a change still waiting: send it anyway. */
  window.addEventListener('pagehide', function () { if (keys(dirty).length) flush(true); });

  /* Row Add to cart: the typed quantity, or the minimum if the box is empty. */
  function addLine(l) {
    if (!l || l.st === 'out') return;
    var n = legal(l.v, draft[l.id] || l.v.mn || 1);
    delete draft[l.id];
    queue(l.id, n, true);
    var row = rowOf(l.id); if (row) paintRow(row, l);
    say('ok', esc(l.p.t) + ' added to your cart (' + n + ' ' + unitWord(n) + ').');
  }
  function removeLine(id) {
    var l = byId(id);
    queue(id, 0, true);
    var row = rowOf(id); if (row && l) paintRow(row, l);
    if (filter === 'picked') render();
    say('ok', esc(l ? l.p.t : (cartLine[id] && cartLine[id].t) || 'Item') + ' removed from your cart.');
  }

  function goCheckout() {
    if (!anyPending()) { location.href = CHECKOUT; return; }
    [$add, $addTop].forEach(function (b) { if (b) { b.disabled = true; b.textContent = 'Saving…'; } });
    flush();
    (function wait() { if (anyPending()) setTimeout(wait, 150); else location.href = CHECKOUT; })();
  }
  $add.addEventListener('click', goCheckout);
  if ($addTop) $addTop.addEventListener('click', goCheckout);

  /* Empty cart, two clicks so a stray click cannot wipe a long order. */
  var armTimer;
  function disarm() {
    [$clear, $clearTop].forEach(function (x) { if (x) { x.classList.remove('is-armed'); x.textContent = 'Empty cart'; } });
  }
  function emptyCart(e) {
    if (!e.currentTarget.classList.contains('is-armed')) {
      [$clear, $clearTop].forEach(function (x) { if (x) { x.classList.add('is-armed'); x.textContent = 'Click again to empty'; } });
      clearTimeout(armTimer);
      armTimer = setTimeout(disarm, 4000);
      return;
    }
    disarm();
    dirty = {}; clearTimeout(flushTimer);
    fetch('/cart/clear.js', { method: 'POST', credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); }).then(function (c) {
        qty = {}; applyCart(c); render(); histDrawn = false;
        closeCartList();
        say('ok', 'Your cart is empty.');
        announceCart();
      }).catch(function () { say('err', 'Your cart could not be emptied. Refresh and try again.'); });
  }
  $clear.addEventListener('click', emptyCart);
  if ($clearTop) $clearTop.addEventListener('click', emptyCart);

  /* ---- totals, the cart list, bottom bar, tracker ---- */
  /* Compact top, Aaron 2 Oct: the bottom bar only comes up once the top
     band's Checkout has scrolled out of view, so it never covers the first
     rows while the same total and Checkout are already on screen. */
  var topInView = true;
  function syncFoot() {
    if ($foot) $foot.classList.toggle('is-on', !topInView && (keys(qty).length > 0 || !!($msg && $msg.textContent)));
  }
  if ($addTop && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (es) {
      topInView = es[es.length - 1].isIntersecting;
      syncFoot();
    }, { rootMargin: '-90px 0px 0px 0px' }).observe($addTop);
  } else {
    topInView = false;
  }

  function paintCartList() {
    if (!$sumLines) return;
    var ids = keys(qty).filter(function (id) { return qty[id]; });
    if (!ids.length) { $sumLines.innerHTML = '<p class="derw-qo-sum__empty">Nothing in your cart yet. Use Add to cart on any line below.</p>'; return; }
    /* Newest cart order first, as the cart lists them. */
    var order = (cart && cart.items || []).map(function (it) { return String(it.variant_id); });
    ids.sort(function (a, b) {
      var ia = order.indexOf(a), ib = order.indexOf(b);
      return (ia === -1 ? -1 : ia) - (ib === -1 ? -1 : ib);
    });
    $sumLines.innerHTML = ids.map(function (id) {
      var l = byId(id), n = qty[id];
      var name = l ? l.p.t : (cartLine[id] && cartLine[id].t) || 'Item';
      var vt = l ? l.v.t : (cartLine[id] && cartLine[id].vt);
      return '<li class="derw-qo-sum__line">' +
        '<span class="derw-qo-sum__lname">' + esc(name) + (vt ? '<span class="derw-qo-sum__lvar"> ' + esc(vt) + '</span>' : '') + '</span>' +
        '<span class="derw-qo-sum__lqty">' + n + ' ×</span>' +
        '<span class="derw-qo-sum__lamt">' + money(lineValue(id, n)) + '</span>' +
        '<button type="button" class="derw-qo-sum__lrm" data-sum-rm="' + id + '" aria-label="Remove ' + esc(name) + ' from your cart">&times;</button>' +
      '</li>';
    }).join('');
  }

  function totals() {
    var pending = anyPending();
    var pend = 0;
    keys(dirty).concat(keys(sending)).forEach(function (id) {
      var l = byId(id); if (!l || l.elig) pend += (qty[id] || 0) - (cartQty[id] || 0);
    });
    var q = Math.max(0, (cartKnown ? cartUnits : 0) + pend);
    var st = stateFor(q);
    var pct = (cartKnown && !cartCode) ? st.currentDiscountPercent : 0;
    var changed = pct !== curPct;
    curPct = pct;

    var units = 0, nLines = 0, std = 0, tot = 0, eligStd = 0;
    keys(qty).forEach(function (id) {
      var n = qty[id]; if (!n) return;
      units += n; nLines++;
      var l = byId(id);
      if (!l || l.elig) eligStd += (!pending && cartLine[id]) ? cartLine[id].ol : (l ? n * l.v.p : 0);
      if (!pending && cartLine[id]) std += cartLine[id].ol;
      else if (l) std += n * l.v.p;
      else if (cartLine[id]) std += cartLine[id].ol;
      tot += lineValue(id, n);
    });

    var itemsTxt = nLines ? nLines + (nLines === 1 ? ' product, ' : ' products, ') + units + ' ' + unitWord(units) : 'Your cart is empty';
    $count.textContent = itemsTxt;
    $total.textContent = money(tot);
    $note.innerHTML = pending ? 'Saving to your cart…'
      : (tot < std ? '<span class="derw-qo__save">You save ' + money(std - tot) + '</span>' + (pct ? ' at ' + pct + '% off.' : '.')
        : (cartCode ? 'A discount code is on your cart, so volume pricing does not apply.' : 'Volume discounts apply automatically.'));
    $add.disabled = !nLines; $clear.disabled = !nLines;
    if ($sumTotal) {
      $sumItems.textContent = itemsTxt;
      $sumStd.textContent = money(std);
      $sumDisc.textContent = '-' + money(std - tot);
      $sumDiscK.textContent = 'Volume discount' + (pct ? ' (' + pct + '% off)' : '');
      $sumDisc.parentNode.hidden = !(std > tot);
      $sumTotal.textContent = money(tot);
      $addTop.disabled = !nLines; $clearTop.disabled = !nLines;
    }
    if ($sync) {
      $sync.textContent = pending ? 'Saving…' : (nLines ? 'Saved' : '');
      $sync.classList.toggle('is-saving', pending);
    }
    paintCartList();
    paintTracker(st, q, eligStd);
    if (changed) repaintRows();
    syncFoot();
    $picked.hidden = !nLines;
    $pickedN.textContent = nLines ? '(' + nLines + ')' : '';
    if (!nLines && filter === 'picked') setFilter('all');
  }

  /* The cart dropdown closes after Empty cart, on a click anywhere else, or
     on Escape (Aaron 2 Oct: it stayed open after emptying the cart). */
  function closeCartList() { root.querySelectorAll('.derw-qo-sum__items[open]').forEach(function (d) { d.open = false; }); }
  document.addEventListener('click', function (e) {
    root.querySelectorAll('.derw-qo-sum__items[open]').forEach(function (d) { if (!d.contains(e.target)) d.open = false; });
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCartList(); });

  if ($sumLines) $sumLines.addEventListener('click', function (e) {
    var b = e.target.closest('[data-sum-rm]'); if (b) removeLine(b.getAttribute('data-sum-rm'));
  });

  var $vCount = $('derw-qo-vcd-count'), $vEarned = $('derw-qo-vcd-earned'), $vLede = $('derw-qo-vcd-lede');
  var $vSplit = $('derw-qo-vcd-split'), $vRail = $('derw-qo-vcd-rail'), $vLive = $('derw-qo-vcd-live');

  function buildRail() {
    var T = tierLists(), sig = T.M.join(',') + '|' + T.P.join(',');
    if ($vRail.getAttribute('data-sig') === sig) return;
    $vRail.setAttribute('data-sig', sig);
    $vRail.innerHTML = T.M.map(function (m, i) {
      var range = i < T.M.length - 1 ? m + ' – ' + (T.M[i + 1] - 1) : m + '+';
      return '<span class="derw-vcd__stage" data-stage="' + i + '"><span class="derw-vcd__dot" aria-hidden="true"></span>' +
        '<span class="derw-vcd__stage-range">' + range + '</span>' +
        '<span class="derw-vcd__stage-label">' + (T.P[i] ? T.P[i] + '% off' : 'Standard price') + '</span></span>';
    }).join('');
  }
  function paintTracker(st, q, eligStd) {
    if (!$vCount) return;
    buildRail();
    var live = cartKnown && !cartCode;
    var stages = $vRail.querySelectorAll('[data-stage]');
    for (var i = 0; i < stages.length; i++) {
      var done = live && q > 0 && i <= st.tierIndex;
      stages[i].classList.toggle('is-done', done);
      stages[i].classList.toggle('is-current', done && i === st.tierIndex);
      stages[i].classList.toggle('is-future', !done);
    }
    if ($vSplit) $vSplit.hidden = true;
    if (!cartKnown) {
      $vCount.textContent = 'Checking your cart';
      $vEarned.hidden = true;
      $vLede.textContent = 'One moment while we read the units in your cart.';
      return;
    }
    $vCount.textContent = q + ' ' + unitWord(q) + ' in your cart';
    if (cartCode) {
      $vEarned.hidden = true;
      $vLede.textContent = 'A discount code is applied to your cart. Volume pricing does not combine with codes, so your code price is what applies at checkout.';
    } else {
      $vEarned.hidden = !(st.currentDiscountPercent > 0);
      $vEarned.textContent = st.currentDiscountPercent + '% DISCOUNT UNLOCKED';
      /* Aaron 2 Oct: the next tier in dollars. What is already in the cart
         alone would save this much more at the next tier; the units added to
         reach it save more on top, so it is "at least". */
      var more = (q > 0 && !st.maximumTierReached) ? Math.round((eligStd || 0) * (st.nextDiscountPercent - st.currentDiscountPercent) / 100) : 0;
      $vLede.textContent = st.maximumTierReached
        ? 'Maximum discount unlocked. Your entire order is at ' + st.currentDiscountPercent + '% off.'
        : 'Add ' + st.unitsToNextTier + (q > 0 ? ' more ' : ' ') + unitWord(st.unitsToNextTier) + ' to unlock ' + st.nextDiscountPercent + '% off' +
          (more >= 100 ? ' and save at least ' + money(more) + ' more on this order.' : '.');
    }
    var msg = $vCount.textContent + '. ' + ($vEarned.hidden ? '' : $vEarned.textContent + '. ') + $vLede.textContent;
    if ($vLive.textContent !== msg) $vLive.textContent = msg;
  }

  function markFilter() {
    root.querySelectorAll('[data-filter]').forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-filter') === filter); });
  }
  function setFilter(f) { filter = f; shown = PAGE_ROWS; markFilter(); render(); }

  /* ---- search, brand, filters ---- */
  var t;
  $q.addEventListener('input', function () {
    clearTimeout(t);
    t = setTimeout(function () {
      shown = PAGE_ROWS;
      if ($q.value && filter === 'picked') { setFilter('all'); return; }
      render();
    }, 120);
  });
  $q.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' || e.key === 'ArrowDown') {
      e.preventDefault();
      clearTimeout(t); shown = PAGE_ROWS;
      if ($q.value && filter === 'picked') setFilter('all'); else render();
      var first = rowsEl.querySelector('input:not([disabled])'); if (first) { first.focus(); first.select(); }
    }
  });
  /* Picking a brand shows that brand: clears the search, and leaves
     Ordered before / In your cart for All products. */
  $brand.addEventListener('change', function () {
    clearTimeout(t); $q.value = ''; shown = PAGE_ROWS;
    if ($brand.value && (filter === 'before' || filter === 'picked')) { setFilter('all'); return; }
    render();
  });
  root.querySelectorAll('[data-filter]').forEach(function (b) {
    b.addEventListener('click', function () { setFilter(b.getAttribute('data-filter')); });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === '/' && !/INPUT|TEXTAREA|SELECT/.test((document.activeElement || {}).tagName || '')) { e.preventDefault(); $q.focus(); $q.select(); }
  });

  /* ---- rows ---- */
  rowsEl.addEventListener('click', function (e) {
    if (e.target.closest('[data-more]')) { shown += PAGE_ROWS; render(); return; }
    var row = e.target.closest('.derw-qo__row'); if (!row) return;
    var l = byId(row.getAttribute('data-id')); if (!l) return;
    if (e.target.closest('[data-addl]')) { addLine(l); return; }
    if (e.target.closest('[data-addlast]')) { draft[l.id] = l.last.q; addLine(l); return; }
    if (e.target.closest('[data-rm]')) { removeLine(l.id); return; }
    var plus = e.target.closest('[data-plus]');
    var b = plus || e.target.closest('[data-step]'); if (!b || l.st === 'out') return;
    var inCart = !!qty[l.id];
    var cur = inCart ? qty[l.id] : (draft[l.id] || 0);
    var inc = l.v.in || 1, mn = l.v.mn || 1, next;
    if (plus) next = cur + parseInt(plus.getAttribute('data-plus'), 10);
    else {
      var d = parseInt(b.getAttribute('data-step'), 10);
      next = d > 0 ? (cur ? cur + inc : mn) : (cur - inc < mn ? 0 : cur - inc);
    }
    next = legal(l.v, next);
    /* In the cart, the stepper edits the cart; otherwise it sets the amount Add to cart will use. */
    if (inCart) queue(l.id, next); else if (next) draft[l.id] = next; else delete draft[l.id];
    paintRow(row, l);
  });
  rowsEl.addEventListener('input', function (e) {
    if (e.target.tagName !== 'INPUT') return;
    var row = e.target.closest('.derw-qo__row'), l = byId(row.getAttribute('data-id')); if (!l) return;
    var raw = e.target.value;
    var n = Math.max(0, parseInt(raw, 10) || 0);
    if (qty[l.id] || isPending(l.id) && dirty[l.id] !== undefined) {
      /* In the cart: an empty box mid-edit is not a removal; typing 0 is. */
      if (raw === '') return;
      if (n !== qty[l.id]) queue(l.id, n);
    } else {
      if (n) draft[l.id] = n; else delete draft[l.id];
    }
    paintRow(row, l);
  });
  rowsEl.addEventListener('focusout', function (e) {
    if (e.target.tagName !== 'INPUT') return;
    var row = e.target.closest('.derw-qo__row'), l = row && byId(row.getAttribute('data-id')); if (!l) return;
    if (qty[l.id] || dirty.hasOwnProperty(l.id)) {
      if (e.target.value === '') { e.target.value = qty[l.id] || ''; }
      else {
        var n = legal(l.v, parseInt(e.target.value, 10) || 0);
        if (n !== (qty[l.id] || 0)) queue(l.id, n, true); else if (dirty.hasOwnProperty(l.id)) flush();
      }
    } else if (draft[l.id]) {
      draft[l.id] = legal(l.v, draft[l.id]);
    }
    paintRow(row, l);
  });
  rowsEl.addEventListener('keydown', function (e) {
    if (e.target.tagName !== 'INPUT') return;
    var go = 0;
    if (e.key === 'Enter' || e.key === 'ArrowDown') go = 1;
    if (e.key === 'ArrowUp') go = -1;
    if (!go) return;
    e.preventDefault();
    /* Enter on a line not yet in the cart with a quantity typed adds it. */
    if (e.key === 'Enter') {
      var row = e.target.closest('.derw-qo__row'), l = row && byId(row.getAttribute('data-id'));
      if (l && !qty[l.id] && draft[l.id]) addLine(l);
    }
    var all = [].slice.call(rowsEl.querySelectorAll('input:not([disabled])'));
    var i = all.indexOf(e.target) + go;
    if (i < 0) { $q.focus(); return; }
    if (all[i]) { all[i].focus(); all[i].select(); }
    else if (go > 0) $add.focus();
  });

  /* Sticky column headers sit under the theme's sticky header when it has one. */
  (function stickyOffset() {
    var h = document.querySelector('.header--sticky, [data-section-type="header"] .header');
    var sticky = h && getComputedStyle(h.closest('.shopify-section') || h).position === 'sticky';
    root.style.setProperty('--derw-qo-sticky', sticky ? (h.closest('.shopify-section') || h).offsetHeight + 'px' : '0px');
  })();

  /* Shopify's theme preview bar covers the bottom bar in preview; sit above it. */
  function clearPreviewBar() {
    var pb = document.getElementById('PBarNextFrameWrapper');
    if (pb && $foot) $foot.style.bottom = pb.offsetHeight + 'px';
  }
  [500, 1500, 4000].forEach(function (ms) { setTimeout(clearPreviewBar, ms); });

  /* ---- Clear all: back to an unfiltered catalogue ---- */
  var $reset = $('derw-qo-reset');
  function syncReset() { $reset.hidden = !($q.value || $brand.value || filter !== 'all' || sortKey); }
  $reset.addEventListener('click', function () {
    clearTimeout(t); $q.value = ''; $brand.value = '';
    sortKey = ''; markSort();
    setFilter('all'); $q.focus();
  });

  /* ---- tabs ---- */
  var tabs = root.querySelectorAll('[data-tab]');
  var $pOrder = $('derw-qo-panel-order'), $pHist = $('derw-qo-panel-history');
  function showTab(name, focus) {
    tabs.forEach(function (b) {
      var on = b.getAttribute('data-tab') === name;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-selected', on ? 'true' : 'false');
      b.tabIndex = on ? 0 : -1;
      if (on && focus) b.focus();
    });
    $pOrder.hidden = name !== 'order';
    $pHist.hidden = name !== 'history';
    if (name === 'history') renderHistory();
    try { history.replaceState(null, '', name === 'history' ? '#history' : location.pathname + location.search); } catch (e) {}
  }
  tabs.forEach(function (b, i) {
    b.addEventListener('click', function () { showTab(b.getAttribute('data-tab')); });
    b.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      var nxt = tabs[(i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
      showTab(nxt.getAttribute('data-tab'), true);
    });
  });

  /* ---- order history ---- */
  var orders = [];
  try { orders = JSON.parse($('derw-qo-orders').textContent || '[]'); } catch (e) { orders = []; }
  var $hist = $('derw-qo-hist');
  var histDrawn = false;

  function pill(label) {
    if (!label) return '';
    var l = label.toLowerCase();
    var cls = /paid|fulfilled|delivered/.test(l) && !/unfulfilled|partially/.test(l) ? ' derw-qo__pill--ok' : (/pending|unfulfilled|partial|authori/.test(l) ? ' derw-qo__pill--open' : '');
    return '<span class="derw-qo__pill' + cls + '">' + esc(label) + '</span>';
  }
  /* A past line can be bought again only if it is still in this practice's
     catalogue and orderable today. */
  function orderable(li) { var l = byId(String(li.v)); return l && l.st !== 'out' ? l : null; }

  /* Order details and tracking on this page, Aaron 2 Oct: "so they don't have
     to go to the account page". Lines shipped together share a tracking
     number and ship date, so they are grouped into one shipment. */
  function carrierUrl(co, num, fallback) {
    var c = (co || '').toLowerCase(), n = encodeURIComponent(num || '');
    if (n) {
      if (/fedex/.test(c)) return 'https://www.fedex.com/fedextrack/?trknbr=' + n;
      if (/ups/.test(c)) return 'https://www.ups.com/track?tracknum=' + n;
      if (/usps|postal/.test(c)) return 'https://tools.usps.com/go/TrackConfirmAction?tLabels=' + n;
      if (/dhl/.test(c)) return 'https://www.dhl.com/us-en/home/tracking/tracking-express.html?tracking-id=' + n;
    }
    return (fallback || '').replace(/&amp;/g, '&');
  }
  function shipmentsOf(o) {
    var map = {}, list = [], waiting = 0;
    o.li.forEach(function (li) {
      if (!li.fd) { waiting += li.q; return; }
      var key = (li.fn || []).join(',') + '|' + li.fd;
      var sh = map[key];
      if (!sh) { sh = map[key] = { co: li.fc || '', nums: li.fn || [], url: li.fu || '', d: li.fd, units: 0 }; list.push(sh); }
      sh.units += li.q;
    });
    return { list: list, waiting: waiting };
  }
  function trackHtml(sh, n) {
    return '<a class="derw-qo__trk" href="' + esc(carrierUrl(sh.co, n, sh.url)) + '" target="_blank" rel="noopener">' + esc(n) + '</a>';
  }
  function shipLine(sh) {
    var nums = sh.nums.length ? sh.nums.map(function (n) { return trackHtml(sh, n); }).join(', ')
      : (sh.url ? '<a class="derw-qo__trk" href="' + esc(carrierUrl('', '', sh.url)) + '" target="_blank" rel="noopener">Track shipment</a>' : 'No tracking number');
    return (sh.co ? '<span class="derw-qo__trk-co">' + esc(sh.co) + '</span> ' : '') + nums;
  }

  function renderHistory() {
    if (histDrawn) return;
    if (!lines.length) { $hist.innerHTML = '<p class="derw-qo__state">Loading the catalogue&hellip;</p>'; return; }
    histDrawn = true;
    if (!orders.length) { $hist.innerHTML = '<p class="derw-qo__state">No orders yet. Your past orders will appear here, ready to buy again.</p>'; return; }
    $hist.innerHTML = orders.map(function (o, oi) {
      var units = o.li.reduce(function (a, li) { return a + li.q; }, 0);
      var okCount = o.li.filter(orderable).length;
      var ships = shipmentsOf(o);
      var first = ships.list[0];
      var headTrack = o.x ? '' : (first
        ? '<span class="derw-qo__ord-trk">Shipped ' + esc(first.d) + ' &middot; ' + shipLine(first) +
            (ships.list.length > 1 ? ' <span class="derw-qo__ord-more">+' + (ships.list.length - 1) + ' more</span>' : '') + '</span>'
        : '<span class="derw-qo__ord-trk is-wait">Not shipped yet</span>');

      var linesHtml = o.li.map(function (li, k) {
        var l = orderable(li);
        var img = li.m ? ' style="background-image:url(&quot;' + esc(li.m) + '&quot;)"' : '';
        var meta = [li.vt, li.k ? 'SKU ' + li.k : ''].filter(Boolean).join(' · ');
        var why = l ? '' : (byId(String(li.v)) ? 'Sold out' : 'No longer available');
        var shipped = li.fd ? 'Shipped ' + li.fd : (o.x ? '' : 'Not shipped yet');
        return '<div class="derw-qo__oline' + (l ? '' : ' is-off') + '">' +
          '<div class="derw-qo__prod"><span class="derw-qo__img"' + img + '></span><span class="derw-qo__txt">' +
            '<span class="derw-qo__name">' + esc(li.t) + '</span><span class="derw-qo__meta">' + esc(meta) + (why ? ' · ' + why : '') +
            (shipped ? ' · ' + esc(shipped) : '') + '</span></span></div>' +
          '<div class="is-num">' + li.q + ' &times; ' + money(li.p) + '</div>' +
          '<div class="is-num">' + money(li.q * li.p) + '</div>' +
          '<button type="button" class="derw-qo__oadd" data-oi="' + oi + '" data-li="' + k + '"' + (l ? '' : ' disabled') + '>Add ' + li.q + '</button>' +
        '</div>';
      }).join('');

      var shipBlock = ships.list.map(function (sh) {
        return '<li><span class="derw-qo__side-d">Shipped ' + esc(sh.d) + ' &middot; ' + sh.units + ' ' + unitWord(sh.units) + '</span>' + shipLine(sh) + '</li>';
      }).join('') + (ships.waiting && !o.x ? '<li><span class="derw-qo__side-d">Not shipped yet</span>' + ships.waiting + ' ' + unitWord(ships.waiting) + '</li>' : '');
      var addr = (o.sa || []).filter(function (x) { return x && x.replace(/[,\s]/g, ''); }).map(esc).join('<br>');
      var row = function (k, v, cls) { return '<div' + (cls ? ' class="' + cls + '"' : '') + '><dt>' + k + '</dt><dd>' + v + '</dd></div>'; };
      var sum = (o.dc ? row('Discounts', '-' + money(o.dc), 'is-save') : '') +
        row('Subtotal', money(o.s)) + row('Shipping', o.sp ? money(o.sp) : 'Free') +
        (o.tx ? row('Tax', money(o.tx)) : '') + row('Total', money(o.t), 'is-total') +
        (o.rf ? row('Refunded', '-' + money(o.rf), 'is-ref') : '');

      var detail = '<div class="derw-qo__ord-detail">' +
          '<div class="derw-qo__ord-lines">' + linesHtml + '</div>' +
          '<aside class="derw-qo__ord-side">' +
            '<section><h4>Tracking</h4>' + (shipBlock ? '<ul class="derw-qo__ships">' + shipBlock + '</ul>' : '<p>' + (o.x ? 'Cancelled' : 'Not shipped yet') + '</p>') + '</section>' +
            (addr || o.sm ? '<section><h4>Ship to</h4>' + (addr ? '<p>' + addr + '</p>' : '') + (o.sm ? '<p class="derw-qo__side-m">' + esc(o.sm) + '</p>' : '') + '</section>' : '') +
            '<section><h4>Order summary</h4><dl class="derw-qo__osum">' + sum + '</dl></section>' +
            (o.nt ? '<section><h4>Order note</h4><p>' + esc(o.nt) + '</p></section>' : '') +
          '</aside>' +
        '</div>';

      return '<article class="derw-qo__ord">' +
        '<div class="derw-qo__ord-head">' +
          '<div><span class="derw-qo__ord-k">Order</span><span class="derw-qo__ord-v derw-qo__ord-num">' + esc(o.n) + '</span></div>' +
          '<div><span class="derw-qo__ord-k">Placed</span><span class="derw-qo__ord-v">' + esc(o.d) + '</span></div>' +
          '<div><span class="derw-qo__ord-k">' + o.li.length + (o.li.length === 1 ? ' product, ' : ' products, ') + units + ' ' + unitWord(units) + '</span>' +
            '<span class="derw-qo__ord-st">' + (o.x ? pill('Cancelled') : pill(o.fs) + pill(o.ff)) + '</span>' + headTrack + '</div>' +
          '<div><span class="derw-qo__ord-k">Total</span><span class="derw-qo__ord-v">' + money(o.t) + '</span></div>' +
          '<div class="derw-qo__ord-act">' +
            '<button type="button" class="derw-qo__toggle" data-toggle="' + oi + '" aria-expanded="false" aria-controls="derw-qo-ol-' + oi + '">Details</button>' +
            '<button type="button" class="derw-qo__again" data-again="' + oi + '"' + (okCount ? '' : ' disabled') + '>Buy again</button>' +
          '</div>' +
        '</div>' +
        '<div class="derw-qo__ord-box" id="derw-qo-ol-' + oi + '" hidden>' + detail + '</div>' +
      '</article>';
    }).join('');
  }

  /* Buy again and per-line Add put the lines straight into the cart (added to
     what is there). Buy again then shows the Quick order tab filtered to In
     your cart, where any quantity can be changed before checking out. */
  function addToCart(list, label, btn) {
    var items = [], skipped = 0;
    list.forEach(function (li) {
      var l = orderable(li);
      if (!l) { skipped++; return; }
      var n = legal(l.v, li.q);
      if (n) items.push({ id: parseInt(l.id, 10), quantity: n });
    });
    if (!items.length) return;
    var was = btn && btn.textContent;
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    flush();
    fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error((res.j && (res.j.description || res.j.message)) || 'Something went wrong adding these items.');
        return loadCart().then(function () {
          announceCart();
          var units = items.reduce(function (a, i) { return a + i.quantity; }, 0);
          var txt = 'Added ' + items.length + (items.length === 1 ? ' product' : ' products') + ' (' + units + ' ' + unitWord(units) + ') from ' + label + ' to your cart.' +
            (skipped ? ' ' + skipped + (skipped === 1 ? ' item is' : ' items are') + ' unavailable and were left out.' : '');
          if (btn && btn.hasAttribute('data-li')) { btn.textContent = 'Added'; say('ok', esc(txt)); return; }
          showTab('order');
          $q.value = ''; $brand.value = '';
          setFilter('picked');
          say('ok', esc(txt) + ' <a href="' + CHECKOUT + '">Check out</a>');
          window.scrollTo({ top: root.getBoundingClientRect().top + window.scrollY - 20, behavior: 'smooth' });
          if (btn) { btn.disabled = false; btn.textContent = was; }
        });
      })
      .catch(function (err) {
        if (btn) { btn.disabled = false; btn.textContent = was; }
        say('err', esc(err.message) + ' Nothing was added.');
      });
  }

  $hist.addEventListener('click', function (e) {
    var tg = e.target.closest('[data-toggle]');
    if (tg) {
      var box = $('derw-qo-ol-' + tg.getAttribute('data-toggle'));
      box.hidden = !box.hidden;
      tg.setAttribute('aria-expanded', box.hidden ? 'false' : 'true');
      tg.textContent = box.hidden ? 'Details' : 'Hide details';
      tg.classList.toggle('is-open', !box.hidden);
      return;
    }
    var ag = e.target.closest('[data-again]');
    if (ag) { var o = orders[+ag.getAttribute('data-again')]; addToCart(o.li, o.n, ag); return; }
    var one = e.target.closest('[data-li]');
    if (one) {
      var od = orders[+one.getAttribute('data-oi')];
      addToCart([od.li[+one.getAttribute('data-li')]], od.n, one);
    }
  });

  /* ---- the shared engine, and cart changes made elsewhere ---- */
  var subscribed = false;
  function subscribeCart() {
    if (subscribed) return;
    var api = window.DERWVolumeDiscount;
    if (!api || typeof api.subscribe !== 'function') { setTimeout(subscribeCart, 300); return; }
    subscribed = true;
    api.subscribe(function (pl) {
      if (!(pl && pl.known)) return;
      cartCode = !!pl.codeOnCart;
      /* Only take the engine's count when nothing is mid-save, so it never
         rolls the tier back to a cart that is about to change. */
      if (!anyPending()) cartUnits = pl.eligibleUnits || 0;
      cartKnown = true;
      totals();
    });
  }
  ['cart:updated', 'cart:change', 'product:added', 'ajaxProduct:added'].forEach(function (evt) {
    document.addEventListener(evt, function () { if (!selfEvent && !anyPending()) loadCart(); });
  });
  window.addEventListener('pageshow', function (e) { if (e.persisted) loadCart(); });
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible' && !anyPending() && lines.length) loadCart();
  });

  /* ---- load ---- */
  var base = '/collections/all?view=quick-order-data&sort_by=best-selling&page=';
  function page(n) {
    return fetch(base + n, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (x) { return JSON.parse(x); });
  }
  var cartFirst = fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
    .then(function (r) { return r.json(); }).catch(function () { return null; });
  page(1).then(function (first) {
    var rest = [];
    for (var n = 2; n <= (first.pages || 1); n++) rest.push(page(n));
    return Promise.all(rest).then(function (more) {
      var all = first.products.slice();
      more.forEach(function (m) { all = all.concat(m.products); });
      return all;
    });
  }).then(function (products) {
    build(products);
    return cartFirst;
  }).then(function (c) {
    if (c) applyCart(c);
    render();
    totals();
    subscribeCart();
    if (location.hash === '#history' || !$pHist.hidden) showTab('history');
    if (window.matchMedia('(min-width: 1000px)').matches) $q.focus();
  }).catch(function () {
    if ($state) $state.textContent = 'The catalogue could not be loaded. Refresh the page to try again.';
  });
})();
